export default "__VITE_ASSET__CGu43ww$__"